.ag{padding:0.5rem;}